module.exports = __webpack_public_path__ + "static/media/icon-search.22d19509.svg";